import React, { useState, useRef } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Container
} from '@mui/material';

// Получаем IP-адрес сервера из URL
const API_URL = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
  ? window.location.protocol + '//' + window.location.hostname + ':9000'
  : '';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const usernameRef = useRef(null);
  const passwordRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // console.log('Отправка данных:', { username, password });

      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password })
      });

      // console.log('Ответ сервера:', response.status);

      if (!response.ok) {
        const errorData = await response.json();
        console.log('Помилка:', errorData);
        throw new Error(errorData.detail || 'Неправильний логін або пароль');
      }

      const userData = await response.json();
      // console.log('Данные пользователя:', userData);
      localStorage.setItem('token', userData.access_token);
      onLogin(userData.user);
    } catch (err) {
      console.error('Помилка авторизації:', err);
      setError(err.message);
    }
  };

  const handleUsernameClick = () => {
    if (usernameRef.current) {
      usernameRef.current.focus();
    }
  };

  const handlePasswordClick = () => {
    if (passwordRef.current) {
      passwordRef.current.focus();
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          py: 2
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            maxWidth: 400,
            backgroundColor: 'background.paper'
          }}
        >
          <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
            Вхід в систему
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              width: '100%',
              '& .MuiTextField-root': {
                marginBottom: 2
              }
            }}
          >
            <Box onClick={handleUsernameClick} sx={{ cursor: 'text' }}>
              <TextField
                required
                fullWidth
                id="username"
                label="Логін"
                name="username"
                autoComplete="username"
                autoFocus
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                variant="outlined"
                inputRef={usernameRef}
                InputProps={{
                  sx: {
                    backgroundColor: 'background.paper',
                    cursor: 'text'
                  }
                }}
              />
            </Box>
            <Box onClick={handlePasswordClick} sx={{ cursor: 'text' }}>
              <TextField
                required
                fullWidth
                name="password"
                label="Пароль"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                variant="outlined"
                inputRef={passwordRef}
                InputProps={{
                  sx: {
                    backgroundColor: 'background.paper',
                    cursor: 'text'
                  }
                }}
              />
            </Box>
            {error && (
              <Typography color="error" sx={{ mt: 2 }}>
                {error}
              </Typography>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Увійти
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login; 